export var defaultLocale = {
    unknowMessage: 'Unknown message type.',
    productTitle: 'Production Information',
    confirmTitle: 'Is this the item you are referring to?',
    skuTitle: 'You need to select the item',
    lazMall: 'LazMall',
    followTitle: 'Follow our store',
    followBtn: 'Follow',
    voucherBtn: 'Collect',
    whereIsMyOrderTitle: 'My Recent Order',
    reviewShippingInformationTitle: 'Review Your Shipping Address',
    reviewShippingInformationItemTip: 'Total item',
    reviewShippingInformationAddress: 'Shipping address:',
    returnRequestTitle: 'New Return Request',
    orderNumber: 'Order Number',
    order: 'Order',
    orderDate: 'Order date',
    returnReason: 'Return reason',
    unpaidOrderTitle: 'Unpaid Reminder',
    unpaidOrderItemTip: 'Total items',
    totalReturns: 'Total returns',
    status: 'Status',
    confirm: 'Confirm',
    select: 'Select',
    change: 'Change',
    view: 'View',
    failedStatus: "Message failed to send. {resend} or {delete}",
    PlacedOn: "Placed on",
    orderDetail: "Order detail",
    moreOrders: "More orders"
};

//# sourceMappingURL=defaultLocale.js.map
